// extracted by mini-css-extract-plugin
export default {"button":"ListButton_button__H1v2P","text":"ListButton_text__3c63d"};